import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {courseLearnerText} from '../courseLearnerText';
import './styles.css';

interface Props {
  dueDate: Date | null;
  setDueDate: (date: Date | null) => void;
  className?: string;
}

const DatePickerComponent = React.memo(
  ({dueDate, setDueDate, className}: Props) => {
    // const isWeekday = (date: Date) => {
    //   const day = getDay(date);
    //   return day !== 0 && day !== 6;
    // };

    function toUTCDateOnly(date: Date | null) {
      return date === null
        ? null
        : new Date(
            Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
          );
    }

    return (
      <div className={`DatePickerContainer ${className ? className : ''}`}>
        <DatePicker
          inline
          selected={dueDate}
          onChange={date => setDueDate(toUTCDateOnly(date))}
          placeholderText={courseLearnerText.DatePlaceholder}
          dateFormat="dd MMMM, yyyy"
          className="DueDateBox"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          fixedHeight
          minDate={new Date(Date.now())}
        />
      </div>
    );
  },
);

export default DatePickerComponent;
